import { render } from "./QuestionTemplate.vue?vue&type=template&id=c7aa4f9a&scoped=true"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js"

import "./QuestionTemplate.vue?vue&type=style&index=0&id=c7aa4f9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7aa4f9a"]])

export default __exports__